import { ReactElement, useEffect } from 'react';
import Card from 'components/Card';
import { Asset, Creator, NoodleProductTypes } from '@typings/graphql-models';
import ConnectWithCreatorTitle from '@components/ConnectWithCreatorTitle';
import PoweredByNoodle from '@components/PoweredByNoodle';
import Image from '@components/Image';
import BackButton from '@components/BackButton';
import isInPopoverWidget from '@helpers/isInPopoverWidget';
import { mixpanelTrack } from '@/providers/Mixpanel';
import classNames from 'classnames';
import s from './ConnectWithCreatorWrapper.module.scss';

type ThisCreator = Pick<Creator, 'slug' | 'name' | 'logoCompact'> & {
  person?: {
    image?: Pick<Asset, 'url'> | null;
  } | null;
  primaryColour?: {
    hex: string;
  } | null;
};

type Props = {
  creator?: ThisCreator | null;
  children?: ReactElement;
  productIcon?: NoodleProductTypes;
  isCreatorView?: boolean;
};

const ConnectWithCreatorWrapper = ({ creator, children, productIcon, isCreatorView = false }: Props): ReactElement => {
  useEffect(() => {
    if (isCreatorView) {
      mixpanelTrack('Visited login page from creator page');
    }
  }, []);

  return (
    <div className={s.wrapper__container}>
      {(creator?.logoCompact?.url || creator?.person?.image?.url) && (
        <Image image={creator?.logoCompact?.url || creator?.person?.image?.url} alt="" className={s.wrapper__image} />
      )}
      <div
        className={classNames(s.wrapper__content, {
          [s.wrapper__content__creator]: isCreatorView,
        })}
      >
        <BackButton className={s.back} isCreatorView={isCreatorView} />
        <div style={{ minHeight: 48 }} />

        {!isCreatorView && (
          <ConnectWithCreatorTitle creatorName={creator?.name} creatorImageUrl={creator?.person?.image?.url} productIcon={productIcon} />
        )}

        <Card
          className={classNames(s.wrapper__form, {
            [s.wrapper__form__creator]: isCreatorView,
          })}
          style={(!creator?.person?.image?.url && !isCreatorView && { border: '1px solid var(--color-gray-25' }) || {}}
        >
          {children}
          {!isCreatorView && !isInPopoverWidget() && <PoweredByNoodle style={{ marginTop: 16 }} />}
        </Card>
        <div className={s.wrapper__spacer} />
      </div>
    </div>
  );
};

export default ConnectWithCreatorWrapper;
